import { TOptions } from 'i18next';

import i18n from '../i18n';

export const translate = (key: string, options?: TOptions): string =>
  i18n.t(key, options);

export const getCurrentLanguage = (): string => i18n.languages[0];
